import type { ChatMessageResponseAllOfSenderBasicInfo } from './chatMessageResponseAllOfSenderBasicInfo';
import type { ChatMessageResponseAllOfSenderSocial } from './chatMessageResponseAllOfSenderSocial';

/**
 * 발신자 정보
 */
export type ChatMessageResponseAllOfSender = {
  /** 사용자 기본 정보 */
  basicInfo: ChatMessageResponseAllOfSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatMessageResponseAllOfSenderSocial;
};
